<template>
  <div class="container print-billing">
    <div>
      <div class="billing-document">
        <!-- Header com logo e informações da empresa -->
        <div class="document-header">
          <div class="row align-items-center">
            <div class="col-md-2">
              <img
                v-if="user.logo_url"
                class="company-logo"
                :src="user.logo_url"
                alt="Logo da empresa"
              />
            </div>

            <div class="col-md-7">
              <div class="company-info">
                <h4 class="company-name">{{ user.rest_home_name }}</h4>
              </div>
            </div>
          </div>
        </div>

        <div class="section-title">
          <h5><i class="fas fa-shopping-cart"></i> {{ buy_list.name }}</h5>
        </div>

        <div class="launch-details-table">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>NOME</th>

                <th>TAMANHO DO ITEM</th>

                <th>QUANTIDADE</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(buy, key) in buy_list.itens" :key="key">
                <td>{{ buy.stock_name }}</td>

                <td>
                  {{ buy.stock_size }} {{ buy.unit_of_measurement_name }}
                </td>

                <td>{{ buy.quantity }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="total-section">
          <div class="row">
            <div class="col-md-8"></div>
            <div class="col-md-4">
              <div class="total-box">
                <strong
                  >TOTAL DE ITENS:
                  {{
                    buy_list && buy_list.itens ? buy_list.itens.length : 0
                  }}</strong
                >
              </div>
            </div>
          </div>
        </div>

        <div class="print-section text-right mt-4">
          <v-btn @click="handleToPrint()" class="btn-print">
            <i class="fas fa-print mr-2"></i>
            IMPRIMIR
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../services/api";

import { userData } from "../../lib/functions";

export default {
  name: "BuyPrintView",

  data() {
    return {
      user: {},

      logo: null,

      loading: false,

      buy_id: null,

      buy_list: [],
    };
  },

  async created() {
    if (this.$route.params.buy_id) {
      this.buy_id = this.$route.params.buy_id;
    }

    const { user, logo } = userData();

    this.user = user;

    this.logo = logo;

    await this.getBuyList();
  },

  methods: {
    async getBuyList() {
      try {
        this.loading = true;

        const { buy_id } = this;

        let params = { buy_id };
        const response = await api.get("/buy/print", { params });

        const { buy_list } = response.data;

        this.buy_list = buy_list;

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    handleToPrint() {
      window.print();
    },
  },
};
</script>

<style scoped>
.print-billing {
  max-width: 210mm;
  margin: 0 auto;
  padding: 20px;
  background: white;
  color: #000;
  font-family: "WorkSans-Regular", sans-serif;
}

.document-header {
  border-bottom: 2px solid #ddd;
  padding-bottom: 20px;
  margin-bottom: 30px;
}

.company-logo {
  max-height: 80px;
  max-width: 100%;
  object-fit: contain;
}

.company-info {
  text-align: left;
}

.company-name {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 5px;
  color: #333;
}

.section-title {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #333;
  color: white;
  border-radius: 4px;
}

.section-title h5 {
  margin: 0;
  font-size: 14px;
  font-weight: bold;
}

.section-title i {
  margin-right: 8px;
}

.launch-details-table {
  margin-bottom: 20px;
}

.launch-details-table table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.launch-details-table th {
  background-color: #f8f9fa;
  padding: 10px 8px;
  border: 1px solid #ddd;
  font-weight: bold;
  text-align: center;
  font-size: 11px;
}

.launch-details-table td {
  padding: 10px 8px;
  border: 1px solid #ddd;
  vertical-align: middle;
}

.total-section {
  margin-bottom: 30px;
}

.total-box {
  text-align: right;
  padding: 15px;
  background-color: #f8f9fa;
  border: 2px solid #333;
  border-radius: 4px;
  font-size: 16px;
}

.print-section {
  margin-top: 40px;
  page-break-inside: avoid;
}

.btn-print {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-print:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.4) !important;
}

@media print {
  .print-billing {
    margin: 0;
    padding: 15mm;
    box-shadow: none;
  }

  .btn-print,
  .print-section {
    display: none !important;
  }

  .document-header {
    border-bottom: 2px solid #000;
  }

  .total-box {
    border: 2px solid #000;
  }

  .section-title {
    background-color: #000 !important;
    color: white !important;
  }

  .launch-details-table th {
    background-color: #f0f0f0 !important;
  }

  .launch-details-table table,
  .launch-details-table th,
  .launch-details-table td {
    border: 1px solid #000 !important;
  }
}
</style>